import FilterObj from './filterResolver.js';

export default FilterObj;